import { useQsFilters } from "@dash/filters";
import { Page, PageHeader } from "@dash/page";
import { SearchWithPaginationSticky } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";

import { ItemSortField } from "@megaron/docs-contracts";
import { ItemFilters, itemFiltersSerializer } from "@megaron/megarax-uri";
import { useClientManager } from "@megaron/react-clients";
import { SortFilter } from "@megaron/serializers";

import { ItemSyncOptionsBar } from "./ItemSyncOptionsBar";
import { TradeItemsFilters } from "./TradeItemsFilters";
import { TradeItemsTable } from "./TradeItemsTable";

export type ItemsFilters = ItemFilters;

export type SortField = SortFilter<ItemSortField>;

export const TradeItemsPage = () => {
  const { filters, setFilter } = useQsFilters(itemFiltersSerializer, {
    searchText: "",
    sort: undefined,
    groups: [],
    isArchived: undefined,
    isInAvailability: undefined,
  });

  const itemsQuery = useClientManager("docs").searchItems().useQuery({
    searchText: filters.searchText,
    sort: filters.sort,
    groups: filters.groups,
    isArchived: filters.isArchived,
    isInAvailability: filters.isInAvailability,
  });

  return (
    <Page
      css={{
        maxWidth: "none",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <PageHeader>Produkty</PageHeader>
      <ItemSyncOptionsBar />

      <SearchWithPaginationSticky
        onSearchChange={setFilter("searchText")}
        searchValue={filters.searchText ?? ""}
        hidePagination
      />

      <TradeItemsFilters
        filters={filters}
        handlers={{
          onGroupsChange: setFilter("groups"),
          onIsArchivedChange: setFilter("isArchived"),
          onSortChange: setFilter("sort"),
          onIsInAvailabilityChange: setFilter("isInAvailability"),
        }}
      />

      <QuerySkeleton query={itemsQuery}>
        {(items) => (
          <TradeItemsTable
            items={items.items}
            isLoading={itemsQuery.isFetching}
            activeSortValue={filters.sort}
            onSortChange={setFilter("sort")}
          />
        )}
      </QuerySkeleton>
    </Page>
  );
};
